var React = require('react');

function VolumeOn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,5.3v5.3h3.6L8,15.1V0.9L3.6,5.3H0z M12,8c0-1.6-0.9-2.9-2.2-3.6v7.2C11.1,10.9,12,9.6,12,8z M9.8,0.2V2\n\tc2.6,0.8,4.4,3.1,4.4,6s-1.9,5.2-4.4,6v1.8C13.3,15,16,11.8,16,8S13.3,1,9.8,0.2z"}));
}

VolumeOn.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = VolumeOn;

VolumeOn.default = VolumeOn;
